const IOVATION_CONFIG_SCRIPT_ID = "iovation-config";
const IOVATION_SCRIPT_ID = "iovation-script";
const IOVATION_CONFIG =
  "var io_install_flash = false;var io_install_stm = false;var io_exclude_stm = 15;";
const IOVATION_SCRIPT_SRC = "https://mpsnare.iesnare.com/snare.js";

function ensureIovationScripts() {
  if (typeof window === "undefined") {
    return;
  }

  if (!document.getElementById(IOVATION_CONFIG_SCRIPT_ID)) {
    const configScript = document.createElement("script");
    configScript.id = IOVATION_CONFIG_SCRIPT_ID;
    configScript.text = IOVATION_CONFIG;
    document.head.appendChild(configScript);
  }

  if (!document.getElementById(IOVATION_SCRIPT_ID)) {
    const script = document.createElement("script");
    script.id = IOVATION_SCRIPT_ID;
    script.src = IOVATION_SCRIPT_SRC;
    script.async = true;
    document.head.appendChild(script);
  }
}

function getIovationDeviceId() {
  if (typeof window === "undefined" || !window.ioGetBlackbox) {
    return null;
  }

  return window.ioGetBlackbox()?.blackbox ?? null;
}

export { ensureIovationScripts, getIovationDeviceId };
